
// import React, { useState } from 'react';
// import { IoLogoWhatsapp } from 'react-icons/io'; 
// import { IoClose } from 'react-icons/io5';

// const WhatsAppWidget = () => {
//   const [isVisible, setIsVisible] = useState(true);

//   const phoneNumber = "8755250061"; 
//   const message = "Hi! I need help with your services.";
//   const waLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

//   if (!isVisible) return (
//     <button 
//       onClick={() => setIsVisible(true)}
//       className="fixed top-10 right-10  bg-[#25d366] p-3 rounded-full shadow-md text-white hover:scale-105 transition-all z-[9999] flex items-center gap-2 group"
//     >
//       <IoLogoWhatsapp size={24} />
//       <span className="max-w-0 overflow-hidden group-hover:max-w-xs transition-all duration-500 ease-in-out text-sm font-medium">
//         Chat with us
//       </span>
//     </button>
//   );

//   return (
//     <div className="fixed top-5 right-5 z-[9999] flex flex-col items-start animate-fade-in">
//       {/* WhatsApp Card */}
//       <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden w-64">
//         {/* Header */}
//         <div className="bg-[#075e54] p-4 text-white flex justify-between items-center">
//           <div className="flex items-center gap-3">
//             <div className="relative flex items-center justify-center w-12 h-12 rounded-full 
//                 bg-gradient-to-br from-green-400 via-green-500 to-green-600 
//                 shadow-[0_8px_20px_rgba(37,211,102,0.6)]
//                 animate-pulseSlow">
//               <IoLogoWhatsapp size={26} className="text-white drop-shadow-md" />
//               <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-400 border-2 border-[#075e54] rounded-full"></span>
//             </div>
//             <div>
//               <p className="text-sm font-bold leading-tight">Support Team</p>
//               <p className="text-[10px] opacity-80">Online</p>
//             </div>
//           </div>
//           <button onClick={() => setIsVisible(false)} className="hover:bg-white/20 rounded-full p-1 transition-colors">
//             <IoClose size={20} />
//           </button>
//         </div>

//         {/* Message Area */}
//         <div className="p-4 bg-[#e5ddd5] relative">
//            <div className="bg-white p-3 rounded-lg rounded-tl-none shadow-sm text-sm text-gray-700 relative">
//              Hello! How we can help you ?
//               {/* Message tail */}
//               <div className="absolute top-0 -left-2 w-0 h-0 border-t-[10px] border-t-white border-l-[10px] border-l-transparent"></div>
//            </div>
//         </div>

//         {/* Action Button */}
//         <div className="p-3 bg-white">
//           <a 
//             href={waLink} 
//             target="_blank" 
//             rel="noopener noreferrer"
//             className="flex items-center justify-center gap-2 bg-[#25d366] text-white py-2 px-4 rounded-xl font-semibold text-sm hover:bg-[#20ba5a] transition-colors shadow-md"
//           >
//             Start Chat
//           </a>
//         </div>
//       </div>
//     </div> 
//   );
// };

// export default WhatsAppWidget;




import React, { useState } from "react";
import { IoLogoWhatsapp } from "react-icons/io";
import { IoClose } from "react-icons/io5";

const WhatsAppWidget = () => {
  const [open, setOpen] = useState(false);

  const waLink =
    "https://wa.me/918755250061?text=Hi!%20I%20need%20help%20with%20your%20services.";

  return (
    <div className="fixed z-[999999] bottom-6 right-6 md:top-6 md:bottom-auto">

      {/* ======= PREMIUM POLISHED POPUP ======= */}
      <div
        className={`
          absolute right-0
          bottom-20 md:top-20 md:bottom-auto
          w-[340px]
          bg-white
          rounded-[24px]
          border border-gray-200
          shadow-[0_25px_60px_rgba(0,0,0,0.18)]
          transition-all duration-700
          ${open 
            ? "opacity-100 translate-y-0 scale-100" 
            : "opacity-0 translate-y-6 scale-[0.96] pointer-events-none"}
        `}
        style={{
          transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
        }}
      >
        {/* Header */}
        <div className="flex items-center gap-4 px-5 py-4 border-b">
          <div className="w-12 h-12 rounded-full bg-[#1FA855] flex items-center justify-center">
            <IoLogoWhatsapp size={22} className="text-white" />
          </div>

          <div className="flex-1 leading-tight">
            <p className="text-[15px] font-semibold text-gray-900">
              Digital Canto
            </p>
            <div className="flex items-center gap-2 mt-1">
              <span className="w-2 h-2 rounded-full bg-green-500"></span>
              <span className="text-xs text-gray-500">
                Online • Support available
              </span>
            </div>
          </div>

          <button onClick={() => setOpen(false)}>
            <IoClose
              size={20}
              className="text-gray-400 hover:text-gray-700 transition"
            />
          </button>
        </div>

        {/* Message */}
        <div className="px-5 py-5 bg-[#F7F9F8]">
          <div className="max-w-[92%] bg-white rounded-2xl px-4 py-3 text-[14px] text-gray-700 shadow-sm leading-relaxed">
            Hello 👋  
            <br />
            Thanks for reaching out to <b>Digital Canto</b>.
            <br />
            Let us know how we can assist you today.
          </div>
        </div>

        {/* CTA */}
        <div className="px-5 pb-5">
          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            className="
              flex items-center justify-center gap-2
              w-full py-3.5 rounded-2xl
              bg-[#1FA855] text-white font-semibold
              hover:bg-[#178F49]
              transition active:scale-[0.97]
            "
          >
            <IoLogoWhatsapp size={18} />
            Continue on WhatsApp
          </a>
        </div>
      </div>

      {/* ======= FLOATING BUTTON ======= */}
      <button
        onClick={() => setOpen(!open)}
        className="
          relative w-16 h-16 rounded-full
          bg-[#1FA855] text-white
          flex items-center justify-center
          shadow-[0_14px_35px_rgba(31,168,85,0.45)]
          transition-transform duration-500
          hover:scale-110
          active:scale-95
        "
        style={{
          transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
        }}
      >
        {!open && (
          <span className="absolute inset-0 rounded-full bg-[#1FA855] animate-ping opacity-20"></span>
        )}
        {open ? <IoClose size={30} /> : <IoLogoWhatsapp size={36} />}
      </button>
    </div>
  );
};

export default WhatsAppWidget;
